import React from "react";
import { FaClock, FaEnvelope, FaMapMarkerAlt, FaUserTie, FaChevronRight, FaExternalLinkAlt } from "react-icons/fa";
import ContactUsFormCard from "../ContactUsFormCard/ContactUsFormCard";
import { Helmet } from "react-helmet-async";

const Contact = () => {
  return (
    <section className="relative bg-zinc-50 py-24 overflow-hidden font-sans selection:bg-black selection:text-white">

    <Helmet>
  <title>Contact| Option Bricks</title>
 
</Helmet>
      
      <div className="container mx-auto px-6 lg:px-12 relative z-10 animate-fade-in-up">
        <div className="max-w-7xl mx-auto">
          
          {/* Header Section */}
          <div className="flex flex-col md:flex-row md:items-end justify-between mb-16 gap-8 border-b border-zinc-200 pb-12">
            <div className="max-w-2xl">
              <div className="inline-flex items-center gap-2 px-4 py-1.5 rounded-full bg-white border border-zinc-200 text-zinc-900 text-xs font-bold tracking-widest uppercase mb-6 shadow-sm">
                <span className="w-2 h-2 rounded-full bg-[#1e6091] animate-pulse"></span>
                Available 24/7 Support
              </div>
              {/* Changed from h2 to h1 for the primary section/page identifier */}
              <h1 className="text-4xl md:text-6xl lg:text-7xl font-extrabold text-black leading-[1.1] tracking-tighter">
                Let’s talk <br />
                <span className="text-[#1e6091]">Business.</span>
              </h1>
            </div>
            
            <div className="bg-white p-6 rounded-2xl shadow-sm border border-zinc-200 md:max-w-xs relative">
              {/* Brand accent line */}
              <div className="absolute top-0 left-0 w-1.5 h-full bg-[#1e6091] rounded-l-2xl"></div>
              <p className="text-zinc-600 text-sm md:text-base italic leading-relaxed">
                "Providing research-driven insights is our passion. We’re here to help you trade smarter and with confidence."
              </p>
            </div>
          </div>

          {/* Main Content Grid */}
          <div className="grid gap-8 lg:gap-12 lg:grid-cols-12 items-stretch">
            
            {/* Left Side: Contact Information (7 Columns) */}
            <div className="lg:col-span-7 space-y-6 flex flex-col">
              
              {/* Premium Profile Card (Brand Blue) */}
              <div className="relative bg-[#1e6091] p-8 md:p-10 rounded-[2rem] shadow-[0_20px_50px_rgba(30,96,145,0.3)] flex flex-col sm:flex-row gap-6 items-start sm:items-center justify-between group overflow-hidden border border-white/10">
                {/* Subtle abstract rings */}
                <div className="absolute -right-10 -top-10 w-40 h-40 border border-white/15 rounded-full group-hover:scale-150 transition-transform duration-700"></div>

                <div className="flex items-center gap-5 relative z-10">
                  <div className="relative shrink-0">
                    <div className="w-20 h-20 bg-white/10 rounded-2xl flex items-center justify-center text-white border border-white/20 shadow-inner">
                      <FaUserTie size={32} />
                    </div>
                    {/* Status dot in pure white to stand out */}
                    <div className="absolute -bottom-2 -right-2 w-7 h-7 bg-white rounded-full border-4 border-[#1e6091] flex items-center justify-center"></div>
                  </div>
                  <div>
                    {/* Changed from h3 to h2 to respect the hierarchy under h1 */}
                    <h2 className="text-2xl font-black text-white tracking-wide">Deepti Sarkar</h2>
                    <p className="text-blue-200 font-bold text-sm tracking-widest uppercase mt-1">Head of Compliance</p>
                  </div>
                </div>

                <a
                  href="tel:+919082280240"
                  className="relative z-10 shrink-0 bg-white text-[#1e6091] px-7 py-3.5 rounded-xl text-sm font-bold shadow-lg hover:bg-blue-50 hover:-translate-y-1 transition-all duration-300 flex items-center gap-2"
                >
                  Call Now <FaChevronRight size={12} />
                </a>
              </div>

              {/* Bento Grid Info Cards */}
              <div className="grid sm:grid-cols-2 gap-6 flex-1">
                
                {/* Email Card */}
                <div className="group bg-white p-8 rounded-[2rem] shadow-sm border border-zinc-200 hover:border-[#1e6091] hover:shadow-xl transition-all duration-300 hover:-translate-y-1">
                  <div className="w-12 h-12 bg-zinc-100 group-hover:bg-[#1e6091] text-zinc-900 group-hover:text-white rounded-xl flex items-center justify-center mb-6 transition-colors duration-300">
                    <FaEnvelope className="text-xl" />
                  </div>
                  {/* Changed from h4 to h3 to follow the Deepti Sarkar h2 block context */}
                  <h3 className="font-bold text-black mb-2 text-lg">Email Address</h3>
                  <a href="mailto:compliance@optionbricks.in" className="text-zinc-500 text-sm hover:text-[#1e6091] transition-colors break-all font-medium">
                    compliance@optionbricks.in
                  </a>
                </div>

                {/* Hours Card */}
                <div className="group bg-white p-8 rounded-[2rem] shadow-sm border border-zinc-200 hover:border-[#1e6091] hover:shadow-xl transition-all duration-300 hover:-translate-y-1">
                  <div className="w-12 h-12 bg-zinc-100 group-hover:bg-[#1e6091] text-zinc-900 group-hover:text-white rounded-xl flex items-center justify-center mb-6 transition-colors duration-300">
                    <FaClock className="text-xl" />
                  </div>
                  {/* Changed from h4 to h3 */}
                  <h3 className="font-bold text-black mb-2 text-lg">Office Hours</h3>
                  <p className="text-zinc-500 text-sm font-medium">Mon - Sat: 9:00 AM - 6:00 PM</p>
                </div>

                {/* Address Card (Spans full width) */}
                <div className="sm:col-span-2 group bg-white p-8 rounded-[2rem] shadow-sm border border-zinc-200 flex flex-col md:flex-row md:items-center justify-between gap-6 hover:shadow-xl hover:border-[#1e6091] transition-all duration-300">
                  <div className="flex items-start gap-5">
                    <div className="w-12 h-12 bg-zinc-100 group-hover:bg-[#1e6091] text-zinc-900 group-hover:text-white rounded-xl flex items-center justify-center shrink-0 transition-colors duration-300">
                      <FaMapMarkerAlt className="text-xl" />
                    </div>
                    <div>
                      {/* Changed from h4 to h3 */}
                      <h3 className="font-bold text-black mb-2 text-lg">Corporate Office</h3>
                      <p className="text-zinc-500 text-sm leading-relaxed max-w-md font-medium">
                        Siddhivinayak CHS, D8, Sector-8, Sanpada, Navi Mumbai - 400705
                      </p>
                    </div>
                  </div>
                  {/* <button className="shrink-0 text-black bg-zinc-100 px-5 py-2.5 rounded-lg font-bold text-sm flex items-center gap-2 hover:bg-[#1e6091] hover:text-white transition-colors duration-300">
                    View on Map <FaExternalLinkAlt size={12} />
                  </button> */}
                </div>
                
              </div>
            </div>

            {/* Right Side: Contact Form (5 Columns) */}
            <div className="lg:col-span-5 flex h-full">
              <div className="w-full bg-white rounded-[2rem] shadow-[0_20px_40px_rgba(0,0,0,0.06)] border border-zinc-200 overflow-hidden relative flex flex-col group">
                {/* Brand Top Accent Border */}
                <div className="absolute top-0 left-0 w-full h-2 bg-[#1e6091] transition-transform duration-500 origin-left scale-x-75 group-hover:scale-x-100" />
                
                <div className="p-8 md:p-10 flex-1 flex flex-col h-full">
                  <div className="mb-8">
                    {/* Changed from h3 to h2 to correctly act as a main sidebar section heading under h1 */}
                    <h2 className="text-2xl font-black text-black mb-2 tracking-tight">Send a Message</h2>
                    <p className="text-sm text-zinc-500 font-medium">Fill out the form below and we'll get back to you shortly.</p>
                  </div>
                  
                  {/* Your Form Component */}
                  <div className="flex-1">
                    <ContactUsFormCard />
                  </div>
                </div>
              </div>
            </div>

          </div>
        </div>
      </div>

      <style jsx>{`
        @keyframes fadeInUp {
          from { opacity: 0; transform: translateY(40px); }
          to { opacity: 1; transform: translateY(0); }
        }
        .animate-fade-in-up {
          animation: fadeInUp 0.8s cubic-bezier(0.16, 1, 0.3, 1) forwards;
        }
      `}</style>
    </section>
  );
};

export default Contact;